import * as actionTypes from '../constants/sms-chat';
import { updateObject } from '../../../../shared/utils/utility';

const initialState = {
  checkExistedChatResult: null,
  checkExistedChatResultError: null,
  checkExistedChatResultLoading: false,
};

const checkExistedChatStart = (state, action) => {
  return updateObject(state, {
    checkExistedChatResultError: null,
    checkExistedChatResultLoading: true,
  });
};

const checkExistedChatSuccess = (state, action) => {
  return updateObject(state, {
    checkExistedChatResult: action.data,
    checkExistedChatResultError: null,
    checkExistedChatResultLoading: false,
  });
};

const checkExistedChatFail = (state, action) => {
  return updateObject(state, {
    checkExistedChatResult: null,
    checkExistedChatResultError: action.error,
    checkExistedChatResultLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_START:
      return checkExistedChatStart(state, action);
    case actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS:
      return checkExistedChatSuccess(state, action);
    case actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_FAIL:
      return checkExistedChatFail(state, action);

    default:
      return state;
  }
};

export default reducer;
